import React from 'react'

import classNames from 'classnames'

import {
  PanelVisitFlagIcon,
  PanelReviewFlagIcon,
  PanelOtherReviewFlagIcon,
  PanelBookmarkFlagIcon,
  PanelRefreshIcon,
} from '@local/assets/icons'
import {
  panelVisitGuideImage,
  panelReviewGuideImage,
  panelOtherReviewGuideImage,
  panelBookmarkGuideImage,
  panelErrorPageImage,
} from '@local/assets/images'

import Clickable from '../Clickable'
import styles from './TabPanelNoContent.module.scss'
import { TabPanelNoContentTypes } from './type'

interface Props {
  type: TabPanelNoContentTypes
  onClick?: () => void
  showJoinButton?: boolean
  isFull?: boolean
}

const TabPanelNoContent = ({ type, onClick, showJoinButton = false, isFull = false }: Props) => {
  const TabPanelNoContentWrapper = ({ children }: { children: React.ReactNode }) => (
    <div className={classNames(styles.no_content_area, styles[`type_${type}`], { [styles.type_full]: isFull })}>
      {children}
    </div>
  )

  if (type === TabPanelNoContentTypes.VISIT)
    return (
      <TabPanelNoContentWrapper>
        <PanelVisitFlagIcon className={styles.icon} aria-hidden="true" />
        <div className={styles.tit_area}>
          <strong>영수증/결제내역 인증, 예약, 주문</strong>한
          <br />
          장소가 나의 기록이 됩니다.
        </div>
        <div className={styles.txt_area}>방문했던 곳을 한 눈에 모아보세요.</div>
        <div className={styles.img_area}>
          <img src={panelVisitGuideImage.src} width="235" height="155" alt="" />
        </div>
        <div className={styles.btn_area}>
          <Clickable className={styles.btn} onClick={onClick}>
            리뷰 참여하기
          </Clickable>
        </div>
      </TabPanelNoContentWrapper>
    )
  else if (type === TabPanelNoContentTypes.REVIEW)
    return (
      <TabPanelNoContentWrapper>
        <PanelReviewFlagIcon className={styles.icon} aria-hidden="true" />
        <div className={styles.tit_area}>
          다녀온 곳의 <strong>리뷰</strong>를 작성하고
          <br />
          실감나는 <strong>클립</strong> 영상을 만들어보세요!
        </div>
        <div className={styles.txt_area}>나의 발자취를 소중한 기록으로 남길 수 있어요.</div>
        <div className={styles.img_area}>
          <img src={panelReviewGuideImage.src} width="262" height="166" alt="" />
        </div>
        {showJoinButton ? (
          <div className={styles.btn_area}>
            <Clickable className={styles.btn} onClick={onClick}>
              리뷰 쓰기
            </Clickable>
          </div>
        ) : null}
      </TabPanelNoContentWrapper>
    )
  else if (type === TabPanelNoContentTypes.REVIEW_OTHER)
    return (
      <TabPanelNoContentWrapper>
        <PanelOtherReviewFlagIcon className={styles.icon} aria-hidden="true" />
        <div className={styles.tit_area}>
          작성한 리뷰나 클립은 아직 없지만
          <br />
          열심히&nbsp;
          <strong>탐색</strong>하는 분이에요!
        </div>
        <div className={styles.img_area}>
          <img src={panelOtherReviewGuideImage.src} width="269" height="230" alt="타인 리뷰 탭패널 설명" />
        </div>
      </TabPanelNoContentWrapper>
    )
  else if (type === TabPanelNoContentTypes.BOOKMARK)
    return (
      <TabPanelNoContentWrapper>
        <PanelBookmarkFlagIcon className={styles.icon} aria-hidden="true" />
        <div className={styles.tit_area}>
          가고싶은 맛집, 카페 저장하고
          <br />
          나의 <strong>리스트</strong>를 만들어 보세요
        </div>
        <div className={styles.txt_area}>여행 코스도 계획하기도 굳~</div>
        <div className={styles.img_area}>
          <img src={panelBookmarkGuideImage.src} width="225" height="180" alt="저장 탭패널 설명" />
        </div>
      </TabPanelNoContentWrapper>
    )
  return (
    <TabPanelNoContentWrapper>
      <img src={panelErrorPageImage.src} className={styles.icon} width="55" height="40" alt="에러 아이콘" />
      <div className={styles.txt_area}>불편을 드려 죄송합니다.</div>
      <div className={styles.tit_area}>다시, 시도해 주실래요?</div>
      <div className={styles.btn_area}>
        <Clickable className={styles.btn_refresh} onClick={onClick}>
          <span className="place_blind">새로고침</span>
          <PanelRefreshIcon className={styles.icon_refresh} aria-hidden="true" />
        </Clickable>
      </div>
    </TabPanelNoContentWrapper>
  )
}

export default TabPanelNoContent
